"use client";

import ServiceTitle from "@/shared/app/ui/text/ServiceTitle";
import { motion } from "framer-motion";
import Image from "next/image";

export default function FirstInfoSection() {
  return (
    <div className="border-t border-[#ECECEC] mt-[-2px]">
      <div className="w-full xl:max-w-[1280px] mx-auto px-5 xl:px-2 py-30 md:py-60">
        {/* 서비스 타이틀 */}

        <ServiceTitle
          badgeText={"교통약자 이동정보 APP"}
          title={"위맵"}
          description={`다양한 사람들과 함께 공간정보를 수집하여,
이동약자에게 접근가능한 편의시설 정보와 길 정보를 제공합니다.`}
        />
      </div>
      {/* 서비스 컨텐츠 */}
      <div className="w-full xl:max-w-[1280px] mx-auto px-5 xl:px-2 py-10 sm:py-14 md:py-20 flex flex-col  xl:flex-row">
        {/* <motion.div
          className="flex flex-col mr-0 xl:mr-20"
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
          variants={{
            hidden: {},
            visible: { transition: { staggerChildren: 0.2 } },
          }}
        > */}
        <div className="flex flex-col mr-0 xl:mr-20">
          {/* 심볼아이콘 */}
          {/* <motion.div
            className="relative w-8 h-8 md:w-14 md:h-14 xl:w-20 xl:h-20 flex"
            variants={{
              hidden: { opacity: 0, y: 10 },
              visible: { opacity: 1, y: 0 },
            }}
            transition={{ duration: 0.5 }}
          > */}
          <div className="relative w-8 h-8 md:w-14 md:h-14 xl:w-20 xl:h-20 flex">
            <Image
              src="/assets/images/page/service/wemap/symbol.svg"
              alt="Symbol Logo"
              fill
              style={{ objectFit: "contain" }}
            />
          </div>
          {/* </motion.div> */}
          {/* <motion.p
            className="mt-5 md:mt-12 xl:mt-16 text-2xl md:text-3xl xl:text-4xl text-black-almostBlack leading-8 md:leading-13 tracking-tight"
            style={{ fontFamily: '"paperlogy-bold", sans-serif' }}
            variants={{
              hidden: { opacity: 0, y: 10 },
              visible: { opacity: 1, y: 0 },
            }}
            transition={{ duration: 0.5 }}
          > */}
          <p
            className="mt-5 md:mt-12 xl:mt-16 text-2xl md:text-3xl xl:text-4xl text-black-almostBlack leading-8 md:leading-13 tracking-tight"
            style={{ fontFamily: '"paperlogy-bold", sans-serif' }}
          >
            일상에 꼭 필요한
            <br />
            정보를 위해!
          </p>
          {/* </motion.p> */}
          {/* <motion.p
            className="text-base md:text-xl xl:text-2xl text-[15px] sm:text-xl sm:leading-8 md:leading-10  mt-4 text-black-300 tracking-tight"
            variants={{
              hidden: { opacity: 0, y: 10 },
              visible: { opacity: 1, y: 0 },
            }}
            transition={{ duration: 0.5 }}
            style={{ fontFamily: '"pre-Medium", sans-serif' }}
          > */}
          <p
            className="text-base md:text-xl xl:text-2xl text-[15px] sm:text-xl sm:leading-8 md:leading-10  mt-4 text-black-300 tracking-tight"
            style={{ fontFamily: '"pre-Medium", sans-serif' }}
          >
            위맵은 다양한 파트너와 시민들의 참여로
            <br />
            공간 정보를 발굴하고, 제공합니다
          </p>
          {/* </motion.p> */}
        </div>
        {/* </motion.div> */}
        <motion.div
          className="grow mt-10 hidden xl:flex"
          initial={{ opacity: 0, x: 50 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true, amount: 0.3 }}
          transition={{ duration: 0.8 }}
        >
          <div className="relative h-[820px] w-full">
            <Image
              src="/assets/images/page/service/wemap/main.png"
              alt="wemap screen"
              fill
              className="object-contain object-right-top"
            />
          </div>
        </motion.div>
      </div>

      {/* 모바일 이미지 */}
      <motion.div
        className="grow mt-1 md:mt-10 flex xl:hidden relative overflow-hidden"
        initial={{ opacity: 0, y: 50 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, amount: 0.3 }}
        transition={{ duration: 0.8 }}
      >
        <div className="relative w-[124%] ml-[-50px] md:w-[120%] flex justify-start ">
          <Image
            src="/assets/images/page/service/wemap/main.png"
            alt="wemap screen"
            width={1200} // 원하는 이미지 원본 width
            height={800} // 이미지 비율에 맞게 height
            style={{ objectFit: "contain" }}
          />
        </div>
      </motion.div>
      {/* 라운드 */}
      <div className="relative h-24 md:h-32 ">
        <div className="absolute inset-0 bg-[#131521] z-0" />
        <div className="absolute inset-x-0 top-0  h-24 md:h32 bg-white rounded-b-[40px] md:rounded-b-[120px] z-10 pt-24 md:pt-32" />
      </div>
    </div>
  );
}
